import React from 'react'
import { Chip, Tooltip } from '@mui/material'

export interface IStatusProps {
  status: string
  color?: string
  bgcolor?: string
  tooltip?: string
  fontSize?: number
}

const Status: React.FC<IStatusProps> = ({ status, color, bgcolor, tooltip, fontSize }) => {
  const chip = (
    <Chip
      size="small"
      label={status}
      sx={{
        borderRadius: '50px',
        height: 24,
        backgroundColor: bgcolor ?? '#E7E7E7',
        color: color ?? '#5D5D5D',
        fontWeight: 500,
        fontSize: fontSize ?? 10,
      }}
    />
  )

  if (tooltip) {
    return (
      <Tooltip title={tooltip} placement="bottom" arrow>
        {chip}
      </Tooltip>
    )
  }

  return chip
}

export default Status
